import { HttpContextToken } from '@angular/common/http';

/** The auth interceptor leaves this request alone: no Bearer token, no refresh on 401. Used by the refresh call. */
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

/**
 * The retry interceptor does not resend this request. Used by the refresh call: if a 502 arrives after the server
 * already rotated the refresh token, a resend would present the old token and end the session.
 */
export const SKIP_RETRY = new HttpContextToken<boolean>(() => false);
